export const REJOIN_REQUIRED_CONSUMER_ERROR_MESSAGES = [
  'no media section found for reuseMid',
  'Duplicate a=msid lines detected',
] as const;
